import $ from 'jquery';
import checkSupport from '../../vendor/check-support';
import '../../vendor/jquery.outside-events';

const cookieBotVideoPlaceholderFallback = `
<div class="video__placeholder cookieconsent-optout-marketing">
  <h2>Sorry, deze video is niet beschikbaar</h2>
  <p>
    Deze video wordt geleverd door YouTube. Om deze content te kunnen tonen hebben wij uw goedkeuring nodig voor het gebruik van de cookies van YouTube.
  </p>
  <a class="btn" href="javascript:Cookiebot.renew()">Wijzig cookievoorkeuren</a>
</div>`;

doAllVideos();
doIframes();

function doAllVideos() {
  if (!$('.video').length) return;

  $('.video').each((_, element) => {
    var container = $(element);
    var wallpaperContainer = $('.wallpaper', container);
    var url = container.attr('data-video');
    var wallpaperImg;
    var videoId;
    var cssClass = 'js-ready';

    if (container.hasClass(cssClass)) return;

    // check if the url is valid
    if (url) {
      videoId = retreiveId(url);
    }

    if (videoId) {
      container.addClass(cssClass);

      wallpaperImg = 'https://img.youtube.com/vi/' + videoId + '/sddefault.jpg';

      // add the wallpaper img
      $(wallpaperContainer)
        .css({ 'background-image': 'url(' + wallpaperImg + ')' })
        .append('<span class="cookieconsent-optin-marketing video-btn" />');

      wallpaperContainer.prepend(createIframe(videoId));

      $('.video-btn', container).on('click', () => {
        if (checkSupport.isTouchDevice()) {
          window.open(url, '_blank');
        } else {
          $(container).addClass('playing');
        }
      });

      // cookieBotVideoPlaceholder is provided in a backend script to have it multilanguagal
      const placeHolder = cookieBotVideoPlaceholder
        ? cookieBotVideoPlaceholder
        : cookieBotVideoPlaceholderFallback;

      $(wallpaperContainer).append(placeHolder);
    }

    // reset everything when clicking outside
    $(element).on('clickoutside', () => {
      $(element).removeClass('playing');

      const iframe = $(element).find('iframe');
      const src = iframe.attr('src');

      if (src) {
        // Stops the video
        iframe.attr('src', '');
        iframe.attr('src', src);
      }
    });
  });
}

function doIframes() {
  if (!$('iframe[src*="youtube.com/embed"]').length) return;

  $('iframe[src*="youtube.com/embed"]').each((_, element) => {
    var iframe = $(element);
    var url = iframe.attr('src');

    var markup = $(
      '<div class="video js-generated" data-video="' + url + '"><div class="wallpaper" /></div>'
    );

    iframe.after(markup);

    iframe.remove();

    doAllVideos();
  });
}

function doCarousel(carousel) {
  $('figure[data-video]', carousel).each((_, element) => {
    var url = $(element).attr('data-video');

    var markup = '<div class="video" data-video="' + url + '"><div class="wallpaper" /></div>';

    $(element).append(markup);

    doAllVideos();
  });
}

function retreiveId(url) {
  var videoId,
    urlArray = url.match(
      /(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
    );

  if (urlArray && urlArray[3].indexOf('youtu') > -1) {
    videoId = urlArray[6];
  } else videoId = false;
  return videoId;
}

function createIframe(videoId) {
  return (
    '<iframe allowfullscreen data-cookieblock-src="https://www.youtube.com/embed/' +
    videoId +
    '?autoplay=1&v=' +
    videoId +
    '&wmode=transparent" data-cookieconsent="marketing" />'
  );
}

export default {
  doCarousel,
};
